import { apiGet } from '../../api'

export const accept_application = query => {
  return apiGet({
    endpoint: `application/accept_application?id=${query}`
  })
}
